import { FC } from 'react';
import { Modal } from 'react-bootstrap';

import { useTranslate } from 'hooks/useTranslate';

import { useEditEquityMarketSharePurchaseContractTemplateModal } from '../context/EditEquityMarketSharePurchaseContractTemplateModalContext';

const EditEquityMarketSharePurchaseContractTemplateModalFooter: FC = () => {
  const { t } = useTranslate();
  const { data, actions } =
    useEditEquityMarketSharePurchaseContractTemplateModal();

  return (
    <Modal.Footer>
      <button
        type="button"
        className="btn btn-light"
        onClick={actions.handleCloseModal}
        disabled={data.isSaving}
      >
        {t('Cancel')}
      </button>
      <button
        type="button"
        className="btn btn-primary"
        onClick={actions.handleSave}
        disabled={
          data.isLoading || data.loadError || data.isSaving || !data.documentId
        }
      >
        <em className="icon ni ni-save mr-1" />
        {t('EquityMarketContractSaveTemplate')}
      </button>
    </Modal.Footer>
  );
};

export default EditEquityMarketSharePurchaseContractTemplateModalFooter;
